// src/utils/platform.js
export function detectPlatform() {
    if (typeof window === "undefined") return "unknown";
  
    const nav = window.navigator;
  
    // Prefer User-Agent Client Hints when available
    const uaData = nav.userAgentData;
    const ua = (nav.userAgent || "").toLowerCase();
  
    const isAndroid =
      (uaData?.platform && uaData.platform.toLowerCase().includes("android")) ||
      ua.includes("android");
  
    const isIOSClassic = /iphone|ipad|ipod/.test(ua);
  
    // iPadOS can masquerade as macOS (Safari)
    const isIPadOSMasquerading =
      ua.includes("macintosh") &&
      typeof nav.maxTouchPoints === "number" &&
      nav.maxTouchPoints > 1;
  
    if (isAndroid) return "android";
    if (isIOSClassic || isIPadOSMasquerading) return "ios";
  
    // Desktop includes laptops, desktop browsers, most tablets not caught above
    return "desktop";
  }
  
  export function buildQueryStringFromParams(params) {
    if (!params) return "";
    const entries = [];
    for (const [k, v] of params.entries()) {
      if (v !== null && v !== undefined && String(v).length > 0) {
        entries.push([k, v]);
      }
    }
    if (!entries.length) return "";
    const qs = new URLSearchParams(entries);
    return `?${qs.toString()}`;
  }
  